export enum PriceType {
  FIXED = 0,
  DYNAMIC = 1
}
